(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // drawers (menu)
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-kp-open]');
    if (o) { const d = document.getElementById(o.dataset.kpOpen); d && d.showModal(); }
    const c = e.target.closest('[data-kp-close]');
    if (c) c.closest('dialog')?.close();
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('kp-drawer')) e.target.close();
    if (e.target.closest('[data-kp-side-open]')) $('#KpSide')?.classList.add('is-open');
    if (e.target.closest('[data-kp-side-close]')) $('#KpSide')?.classList.remove('is-open');
  });

  // hero carousel: dots + autoplay
  $$('[data-kp-hero]').forEach(h => {
    const track = $('[data-kp-track]', h), slides = $$('.kp-slide', h), dots = $('[data-kp-dots]', h);
    if (!track || slides.length < 2) return;
    slides.forEach((s, i) => { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', `スライド ${i + 1}`); b.onclick = () => go(i); dots.appendChild(b); });
    const bs = $$('button', dots);
    const go = i => track.scrollTo({ left: slides[i].offsetLeft - (track.clientWidth - slides[i].clientWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
    const cur = () => { const mid = track.scrollLeft + track.clientWidth / 2; let best = 0, d = 1e9; slides.forEach((s, i) => { const dd = Math.abs(s.offsetLeft + s.clientWidth / 2 - mid); if (dd < d) { d = dd; best = i; } }); return best; };
    const mark = () => { const c = cur(); bs.forEach((b, i) => b.setAttribute('aria-current', String(i === c))); };
    track.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true }); mark();
    if (!reduce) setInterval(() => { if (document.hidden || h.matches(':hover')) return; const c = cur(); go(c + 1 >= slides.length ? 0 : c + 1); }, 5000);
  });

  // ranking tabs
  $$('[data-kp-tabs]').forEach(t => {
    const tabs = $$('[data-kp-tab]', t), panels = $$('[data-kp-panel]', t);
    tabs.forEach(b => b.addEventListener('click', () => { tabs.forEach(x => x.setAttribute('aria-selected', String(x === b))); panels.forEach(p => p.hidden = p.dataset.kpPanel !== b.dataset.kpTab); }));
  });

  // product page
  const pdp = $('[data-kp-product]');
  if (pdp) {
    const track = $('[data-kp-gtrack]', pdp), slides = $$('.kp-gal__slide', pdp), thumbs = $$('[data-kp-thumb]', pdp), curEl = $('[data-kp-gcur]', pdp);
    let idx = 0;
    const go = (i, smooth = true) => { if (!slides[i]) return; idx = i; track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' }); };
    const mark = () => { const i = Math.round(track.scrollLeft / track.clientWidth); idx = i; if (curEl) curEl.textContent = i + 1; thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i))); const t = thumbs[i]; t && t.parentElement.scrollWidth > t.parentElement.clientWidth && t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); };
    track?.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
    thumbs.forEach(t => t.addEventListener('click', () => go(Number(t.dataset.kpThumb))));
    $('[data-kp-gprev]', pdp)?.addEventListener('click', () => go(idx > 0 ? idx - 1 : slides.length - 1));
    $('[data-kp-gnext]', pdp)?.addEventListener('click', () => go(idx < slides.length - 1 ? idx + 1 : 0));
    const toMedia = id => { const i = slides.findIndex(s => s.dataset.mediaId === String(id)); if (i >= 0) go(i); };

    const sel = $('[data-kp-variant]', pdp), groups = $$('[data-kp-opt]', pdp).filter(g => g.querySelector('[data-value]'));
    const prices = $$('[data-kp-price]'), compare = $('[data-kp-compare]', pdp), add = $('[data-kp-add]', pdp);
    const choices = () => groups.map(g => g.querySelector('[aria-pressed=true]')?.dataset.value);
    const refresh = (fromColor) => {
      const ch = choices();
      groups.forEach((g, gi) => { const lab = g.querySelector('[data-kp-optval]'); if (lab) lab.textContent = ch[gi] || ''; });
      // mark unavailable values for the last option (size) given the others
      const opts = [...sel.options].map(o => ({ o, v: JSON.parse(o.dataset.options) }));
      groups.forEach((g, gi) => g.querySelectorAll('[data-value]').forEach(b => {
        const ok = opts.some(({ o, v }) => v[gi] === b.dataset.value && o.dataset.available === 'true' && v.every((x, k) => k === gi || !ch[k] || x === ch[k]));
        b.dataset.unavailable = String(!ok);
      }));
      const m = opts.find(({ v }) => v.every((x, k) => x === ch[k]));
      if (!m) { add.disabled = true; add.textContent = '在庫なし'; return; }
      sel.value = m.o.value;
      prices.forEach(p => p.textContent = m.o.dataset.price);
      if (compare) { compare.textContent = m.o.dataset.compare; compare.hidden = !m.o.dataset.compare; }
      const avail = m.o.dataset.available === 'true'; add.disabled = !avail; add.textContent = avail ? 'カートに追加' : '売り切れ';
      if (fromColor && m.o.dataset.media) toMedia(m.o.dataset.media);
      const u = new URL(location.href); u.searchParams.set('variant', m.o.value); history.replaceState({}, '', u);
    };
    groups.forEach(g => g.addEventListener('click', e => {
      const b = e.target.closest('[data-value]'); if (!b) return;
      g.querySelectorAll('[data-value]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      refresh(!!b.closest('.kp-swatches'));
    }));
    if (sel && groups.length) refresh(false);
    if (sel && new URL(location.href).searchParams.has('variant')) { const o = sel.selectedOptions[0]; o?.dataset.media && requestAnimationFrame(() => toMedia(o.dataset.media)); }

    $$('[data-kp-qty]', pdp).forEach(b => b.addEventListener('click', () => { const i = $('input[name=quantity]', pdp); i.value = Math.max(1, (Number(i.value) || 1) + Number(b.dataset.kpQty)); }));
    const sgm = $('#kp-sgm', pdp);
    if (sgm && sgm.showModal) {
      $('[data-kp-sg-open]', pdp)?.addEventListener('click', () => sgm.showModal());
      sgm.addEventListener('click', e => { if (e.target === sgm || e.target.closest('[data-kp-sg-close]')) sgm.close(); });
    } else if (sgm) {
      $('[data-kp-sg-open]', pdp)?.addEventListener('click', () => $('#kp-size')?.scrollIntoView({ behavior: 'smooth' }));
    }
    $('[data-kp-sticky-add]')?.addEventListener('click', () => { if (add.disabled) { $('.kp-opt', pdp)?.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } add.click(); });

    // recently viewed
    const box = $('[data-kp-recent]');
    if (box) {
      const me = box.dataset.current, key = 'kp_recent';
      let list = []; try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) {}
      const show = list.filter(h => h !== me).slice(0, 10);
      try { localStorage.setItem(key, JSON.stringify([me, ...list.filter(h => h !== me)].slice(0, 20))); } catch (e) {}
      if (show.length) {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        Promise.all(show.map(h => fetch(`${root}products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null))).then(ps => {
          const yen = c => '¥' + Math.round(c / 100).toLocaleString('ja-JP');
          const html = ps.filter(Boolean).map(p => `<div class="kp-card"><a class="kp-card__media" href="${p.url}">${p.featured_image ? `<img src="${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=500" alt="" loading="lazy">` : ''}</a><div class="kp-card__badges"></div><a class="kp-card__title" href="${p.url}">${p.title.replace(/</g, '&lt;')}</a><div class="kp-card__price">${yen(p.price)}</div></div>`).join('');
          if (html) { $('[data-kp-recent-list]', box).innerHTML = html; box.hidden = false; }
        });
      }
    }
  }

  // cart coupon (Shopify cart discount codes)
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const rerender = d => { const html = d.sections && d.sections['cart-drawer']; if (!html) return; const doc = new DOMParser().parseFromString(html, 'text/html'); const f = doc.querySelector('[data-cart-drawer-inner]'), o = document.querySelector('#CartDrawer [data-cart-drawer-inner]'); if (f && o) o.replaceWith(f); };
  const setCode = code => fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code, sections: ['cart-drawer'] }) }).then(r => r.json());
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-kp-coupon]'); if (!f) return; e.preventDefault();
    const code = f.discount.value.trim(); if (!code) return;
    setCode(code).then(d => { rerender(d); const ok = (d.discount_codes || []).find(x => x.code.toLowerCase() === code.toLowerCase() && x.applicable);
      if (!ok) { const nf = document.querySelector('#CartDrawer [data-kp-coupon]'); if (nf) { const m = document.createElement('p'); m.className = 'kpc__msg'; m.textContent = 'このクーポンコードはご利用いただけません。'; nf.after(m); } } });
  });
  document.addEventListener('click', e => { if (e.target.closest('[data-kp-coupon-remove]')) setCode('').then(rerender); });
})();
